<template>
  <div>
    <TopBar />

    <HoursInput v-model="spentHoursDefault" step="0.5" label="Default hours" />

    <v-card :loading="loading">
      <v-toolbar color="deep-purple darken-4" dark>
        <v-toolbar-title>
          Added workers
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="sheet = !sheet" :disabled="loading"><v-icon>mdi-plus</v-icon></v-btn>
        <v-btn icon @click="doSaveWorkLogs" color="green" :loading="loading"><v-icon>mdi-check</v-icon></v-btn>
      </v-toolbar>

      <v-list>
        <v-list-item v-if="selectedWorkers.length === 0">
          No employees selected. Press "+" button
        </v-list-item>
        <v-list-item
          v-for="(workLog, index) in selectedWorkers"
          :key="`selected-user-${index}`"
        >
          <v-list-item-avatar>
            <v-img :src="workLog.photo || `${publicPath}img/no-photo.png`"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="workLog.name"></v-list-item-title>
            <v-list-item-subtitle v-text="workLog.workerType + ' at ' + workLog.employeeType"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-item-group>
              <v-list-item-action-text v-text="workLog.spentHours + ' hrs.'"></v-list-item-action-text>
              <v-btn icon small @click="workLog.spentHours - 0.5 >= 0 ? workLog.spentHours -= 0.5 : 0"><v-icon>mdi-minus</v-icon></v-btn>
              <v-btn icon small @click="workLog.spentHours + 0.5 <= 23 ? workLog.spentHours += 0.5 : workLog.spentHours"><v-icon>mdi-plus</v-icon></v-btn>
            </v-item-group>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
    <v-bottom-sheet v-model="sheet" scrollable>
      <v-card>
        <v-card-title>Select workers</v-card-title>
        <v-card-text style="height: 300px">
          <v-list two-line>
            <template v-for="(worker, index) in workers">
              <v-list-item :key="worker.workerId" >
                <v-list-item-avatar>
                  <v-avatar size="32px" tile>
                    <img
                      :src="worker.photo || `${publicPath}img/no-photo.png`"
                      :alt="worker.name"
                    >
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ worker.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ worker.workerType }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon color="blue" @click="addWorker(worker)" v-if="! isWorkerAdded(worker.workerId)">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn icon color="red" @click="removeWorker(worker.workerId)" v-else>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`divider-${worker.workerId}`" v-if="index < workers.length - 1" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>

    </v-bottom-sheet>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TopBar from '../components/TopBar'
import HoursInput from "../components/HoursInput"

export default {
  components: {
    TopBar,
    HoursInput
  },
  data () {
    return {
      sheet: false,
      selectedWorkers: [],
      allWorkers: [],
      publicPath: process.env.BASE_URL,
      spentHoursDefault: 1,
      loading: false,
    }
  },
  methods: {
    ...mapActions(['fetchWorkers', 'saveWorkLogs']),
    addWorker (worker) {
      console.log(worker)
      this.selectedWorkers.push({
        name: worker.name,
        workerId: worker.workerId,
        photo: worker.photo,
        employeeType: worker.employeeType,
        workerType: worker.workerType,
        spentHours: parseFloat(this.spentHoursDefault) || 1
      })
    },
    removeWorker (id) {
      this.selectedWorkers = this.selectedWorkers.filter(item => item.workerId !== id)
    },
    isWorkerAdded (id) {
      return this.selectedWorkers.find(o => o.workerId === id) !== undefined
    },
    doSaveWorkLogs () {
      this.loading = true
      this.sheet = false
      this.saveWorkLogs(this.workLogsToSave).then(() => {
        this.$router.push('/')
      }).catch(err => console.log(err))
    }
  },
  computed: {
    ...mapGetters(['getUser', 'workers', 'activeWS']),
    workLogsToSave () {
      const workLogs = {
        workSessionId: this.activeWS.workSessionId,
        workLogs: this.selectedWorkers.map(worker => {
          return {
            workerId: worker.workerId,
            spentHours: worker.spentHours
          }
        }),
      }

      return workLogs
    }
  },
  created () {
    this.fetchWorkers()
    if (this.getUser.workSession === null || this.getUser.workSession === undefined) {
      this.$router.push('/worksession/create')
    }
  }
}
</script>
